// ALERT!!! snackbar at line 565 & remove this line *****************************
//map dependencies
import uploadImage_4 from "./uploadImage_4";
import upload2 from './uploadImage_2'


// ...

var geo = require('geo-hash')
var GoogleMapsLoader = require('google-maps')
GoogleMapsLoader.KEY = 'AIzaSyA2kK1nMxVgMkLx3M-hXodPolnlr29_vXs'
GoogleMapsLoader.LIBRARIES = ['places']
GoogleMapsLoader.VERSION = '3.33'
var ls = require('local-storage');
import axios from 'axios'
//
import router from '../../../router'
import gen from '../gen'

const state = {
  travelInfo: '',
  showHideMapInput: 'hide-map-input',
  mapLoader: false,
  searchBox: {},
  markers: {},
  map: {},
  getCenter: false,
  input: '',
  showMap: false,
  //
  geohash_uploadImage_3: '',
  geoLocIsAvailable_uploadImage_3: false,
  placeServices: {},
  locationAddress: '',
  geohashVal: ''
}

const getters = {
  showHideMapInput: state => state.showHideMapInput,
  mapLoader: state => {
    return state.mapLoader
  },
  showMap: state => state.showMap,
  addressDetails: state => state.addressDetails,
  locationAddress: state => state.locationAddress
}

const mutations = {
  getInitAddress(state2, payload) {
    actions.getAddress(state, payload.lat, payload.lng).then((res) => {
      state.locationAddress = res[1].formatted_address
      //upload2.state. openMapDialog = false
    })
  },
  //*******************MAP SETUP*******************
  //getting map
  getMap(state, map1) {
    GoogleMapsLoader.load(function (google) {
      // Create the search box and link it to the UI element.
      if (state.markers[0] !== undefined) {
      }
      mutations.setMap(state, map1)

      mutations.searchInput(state)

      // state.showHideMapInput = 'show-map-input'
      //
      setTimeout(() => {
        if (state.searchBox) {
          state.searchBox.addListener('places_changed', function () {
            var place = state.searchBox.getPlaces()[0];

            // Clear out the old markers.
            state.markers.forEach(function (marker) {
              marker.setMap(null);
            });
            state.markers = []


            var bounds = new google.maps.LatLngBounds();

            // Create a marker for each place.
            mutations.createMarker(state, place.geometry.location)

            //
            if (place.geometry.viewport) {
              // Only geocodes have viewport.
              bounds.union(place.geometry.viewport);
            } else {
              bounds.extend(place.geometry.location);
            }
            state.map.fitBounds(bounds);
          });
        }

      },
        200
        // 2000
      )

    })
  },
  //setting up the map
  setMap(state, map1) {
    setTimeout(() => {
      if (document.getElementById('myMap')) {
        GoogleMapsLoader.load(function (google) {
          let lat
          let lng
          if (state.markers.length !== 0) {
            lat = state.markers[0].getPosition().lat()
            lng = state.markers[0].getPosition().lng()
          }
          else {
            lat = (map1.lat)
            lng = (map1.lng - 0.035)
          }
          //
          state.map = {}
          state.map = new google.maps.Map(document.getElementById('myMap'), {
            center: new google.maps.LatLng(lat, lng), //map attributes
            scrollwheel: false,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            zoom: 14, //was 18 earlier // changes for imageDetPage
            minZoom: 4, //the less is the number the less one can zoom out
            maxZoom: 21,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER
            },
            styles: router.currentRoute.path.indexOf('imageDetails') !== -1 ? [
              {
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#f5f5f5"
                  }
                ]
              },
              {
                "elementType": "labels.icon",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#616161"
                  }
                ]
              },
              {
                "elementType": "labels.text.stroke",
                "stylers": [
                  {
                    "color": "#f5f5f5"
                  }
                ]
              },
              {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#bdbdbd"
                  }
                ]
              },
              {
                "featureType": "poi",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#eeeeee"
                  }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#757575"
                  }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#e5e5e5"
                  }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#9e9e9e"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#ffffff"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#757575"
                  }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#dadada"
                  }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#616161"
                  }
                ]
              },
              {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#9e9e9e"
                  }
                ]
              },
              {
                "featureType": "transit",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#e5e5e5"
                  }
                ]
              },
              {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#eeeeee"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#c9c9c9"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#9e9e9e"
                  }
                ]
              }
            ] : {}
          })
          if (router.currentRoute.path.indexOf('/id/') !== -1) {
          }
        })
      }
    },
      0
      // 1000
    )
    //
  },
  // setting up the search input box
  searchInput(state2) {
    GoogleMapsLoader.load(function (google) {
      setTimeout(() => {
        if (state.searchBox) {
          state.input = document.getElementById('pac-input')
          let ele = document.getElementById('pac-input')
          console.log("I come here")
          state.searchBox = new google.maps.places.SearchBox(ele)
          state.map.addListener('bounds_changed', function () {
            ele.setAttribute('autocomplete', 'on')
            state.searchBox.setBounds(state.map.getBounds())
          })
        }
      }, 100)
    })

  },
  //********************* X ***************************
  skip_uploadImage_3(state, payload) {
    //
    //
    let geohash = ''
    let addressArr = []
    let hasGeohash = false

    //
    //decode geohash
    let lat = geo.decode(geohash).lat
    let lon = geo.decode(geohash).lon
    //
    mutations.getSpotTypeSuggestions(state, {
      lat,
      lon
    })
    //
    //route //go to imageUpload_4
    router.push({
      path: '/uploadImage_4',
      query: {
        url: payload.url,
        resourceType: payload.resourceType,
        publicId: payload.publicId,
        //
        createdAt: payload.createdAt,
        //
        caption: payload.caption,
        emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
        //
        shareSpotLocation: JSON.stringify({
          geohash,
          addressArr //if empty in url, vanish on refresh
        }),
        hasGeohash
      }
    })
  },
  //when component is created
  getMarkerOnCurrentLoc(state, payload) {
    GoogleMapsLoader.load(function (google) {
      state.showHideMapInput = 'hide-map-input'
      //  actions.getShopPosition(state).then(function (map) {
      if (payload.isLocAvailable === 'true' || payload.isLocAvailable === true) {
        let lat = geo.decode(payload.geohash).lat
        let lng = geo.decode(payload.geohash).lon

        actions.getAddress(state, lat, lng).then((res) => {
          state.locationAddress = res[1].formatted_address
          //upload2.state. openMapDialog = false
        })
        //
        // according to new ui, spot type has to be on 1st upload screen
        mutations.getSpotTypeSuggestions(state, {
          lat,
          lon: lng
        })
        let newCoords = {lat, lng}
        mutations.createMarker(state, newCoords)
        mutations.getMap(state, newCoords)
      } else {
        let newCoords = {lat: 52.5065133, lng: 13.1445565} // default location here !!!!!
        if (router.currentRoute.path.indexOf('/id/') === -1) {
          if (Object.keys(state.markers).length !== 0 && router.currentRoute.fullPath.includes('/uploadImage_2')) {
            actions.getAddress(state, Object.values(state.markers)[0].getPosition().lat(), Object.values(state.markers)[0].getPosition().lng()).then((res) => {
              document.getElementById('pac-input').innerText = res[1].formatted_address
              setTimeout(() => {
                console.table({table: document.getElementById('pac-input').innerText})
              }, 2000)
              //upload2.state. openMapDialog = false
            })
            mutations.getMap(state, {lat: Object.values(state.markers)[0].getPosition().lat(), lng: Object.values(state.markers)[0].getPosition().lng()})
            mutations.createMarker(state, {lat: Object.values(state.markers)[0].getPosition().lat(), lng: Object.values(state.markers)[0].getPosition().lng()})
          }
          else {
            mutations.getMap(state, newCoords)
            mutations.createMarker(state, newCoords)
          }
        }
        else {
          mutations.getMap(state, newCoords)
        }
      }
      // mutations.getMarkerPosition(state, {geohash: payload.geohash, })
      //  })
    })
  },
  //creating the marker on position provided
  createMarker(state2, pos) {

    if (state.map) {
      GoogleMapsLoader.load(function (google) {
        state.markers = []

        setTimeout(() => {
          state.markers.push(new google.maps.Marker({
            map: state.map,
            position: pos,
            draggable: router.currentRoute.path.indexOf('/id/') === -1 ? true : false//marker attributes
          }));
          /* actions.getAddress(state,pos.lat, pos.lng ).then((res) => {
             state.locationAddress = res.formatted_address
           }) */
        },
          // 0
          100
        )
      })
    }
  },
  selectMarkerLocation() {
    //
    let markerLat = ''
    let markerLng = ''
    //
    state.markers.forEach(function (marker) {
      markerLat = marker.getPosition().lat()
      markerLng = marker.getPosition().lng()
      state.geohashVal = geo.encode(markerLat, markerLng)
      actions.getAddress(state, markerLat, markerLng).then((res) => {
        state.locationAddress = res[1].formatted_address
        state.geoLocIsAvailable_uploadImage_3 = true

        upload2.state.openMapDialog = false
        window.thisOfVueComp.$modal.hide('mapModal')
      })
    })
  },
  // get lat lng of marker
  getMarkerPosition(state2, payload) {
    //
    //
    let markerLat = ''
    let markerLng = ''
    //
    state.markers.forEach(function (marker) {
      markerLat = marker.getPosition().lat()
      markerLng = marker.getPosition().lng()
    })
    //
    //getting address
    let geohash = payload.geohash
    let addressArr = []
    let geoLocIsAvailable = payload.geoLocIsAvailable
    if (payload.geoLocIsAvailable != "false" && payload.geoLocIsAvailable != false) {
      actions.getAddress(state, markerLat, markerLng).then(async function (address) {
        //
        geohash = geo.encode(markerLat, markerLng)
        let addressArr = await actions.arrayOfFormattedAddress(state2, address)
        geoLocIsAvailable = true
        //
        router.push({
          path: '/uploadImage_5',
          query: {
            url: payload.url,
            resourceType: payload.resourceType,
            publicId: payload.publicId,
            //
            createdAt: payload.createdAt,
            //
            spotType: JSON.stringify(payload.spotType),
            caption: payload.caption,
            emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
            //
            geohash,
            shareSpotLocation: JSON.stringify({
              geohash, //q
              addressArr, //if empty in url, vanish on refresh
              addressString: address[1].formatted_address
            }),
            geoLocIsAvailable, //q //const
            anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
            pic_desc: state.travelInfo,
            _mon2: payload._mon2,
            _dur2: payload._dur2
          }
        })
        //
        //decode geohash
        /* let lat =  geo.decode(geohash).lat
        let lon =  geo.decode(geohash).lon
        //
        mutations.getSpotTypeSuggestions(state, {
          lat,
          lon
        })
        path: '/uploadImage_3',
                query: {
                  url,
                  resourceType,
                  publicId,
                  //
                  createdAt,
                  //
                  geohash,
                  geoLocIsAvailable,
                  //
                  caption,
                  emotionalAppeal: JSON.stringify(emotionalAppeal),
                  spotType:  JSON.stringify(spotType),
                  anyoneCanVisitThisSpot
        //
        //route //go to imageUpload_4 */
      })
    } else {
      router.push({
        path: '/uploadImage_5',
        query: {
          url: payload.url,
          resourceType: payload.resourceType,
          publicId: payload.publicId,
          //
          createdAt: payload.createdAt,
          //
          spotType: JSON.stringify(payload.spotType),
          caption: payload.caption,
          emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
          //
          geohash,
          shareSpotLocation: JSON.stringify({
            geohash, //q
            addressArr, //if empty in url, vanish on refresh
            addressString: ''
          }),
          geoLocIsAvailable, //q //const
          anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
          pic_desc: state.travelInfo
        }
      })
    }
  },
  getDrivingDirections(state2, payload) {
    if (state.map) {
      let origin = payload.origin // {lat: geo.decode('u336xw2h1shj').lat, lng: geo.decode('u336xw2h1shj').lon}
      let destination = payload.destination //{lat: geo.decode('u336xqrfbe20').lat, lng: geo.decode('u336xqrfbe20').lon}
      let directionsService = new google.maps.DirectionsService;
      let directionsDisplay = new google.maps.DirectionsRenderer;
      directionsDisplay.setMap(state.map);
      calculateAndDisplayRoute(directionsService, directionsDisplay);
      function calculateAndDisplayRoute(directionsService, directionsDisplay) {
        let icon = {
          url: `https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2_hdpi.png`,//, // url
          scaledSize: new google.maps.Size(25, 40) // to change size of marker icon
        }


        let iconStrt = {
          url: `https://www.google.com/maps/vt/icon/name=icons/spotlight/directions_destination_measle_8x.png&scale=2`,
          scaledSize: new google.maps.Size(15, 15)
        }

        directionsService.route({
          origin,
          destination,
          optimizeWaypoints: true,
          travelMode: 'DRIVING'
        }, function (response, status) {
          if (status === 'OK') {
            new google.maps.DirectionsRenderer({
              map: state.map,
              directions: response,
              suppressMarkers: true
            });

            state.markers.forEach((mrk, index) => {
              mrk.setMap(null)
            })

            let marker = new google.maps.Marker({
              position: response.routes[0].legs[0].end_location,
              map: state.map,
              icon
            });

            let marker2 = new google.maps.Marker({
              position: response.routes[0].legs[0].start_location,
              map: state.map,
              icon: iconStrt
            });
            //directionsDisplay.setDirections(response);
            //state.markers[0].setMap(null)
          } else {
            // state.markers[0].setMap(null)
            // snackbar here !!!!!!!!!!!!!!!!!!!!!!!
            gen.mutations.snackbar_alert(state, {msg: 'Directions request failed due to ' + status})
            //  window.alert('Directions request failed due to ' + status);
          }
        });
      }
    }
  },
  //when locate me button is clicked
  //I haven't done it though because the way my map opend was a bit different but your's will open on your current location
  //whenever you reopen, so better store it in some letiable so that you dont have to call getShopPosition again
  getCurrentGeoLocation() {
    if (state.map) {
      state.showHideMapInput = 'hide-map-input'
      actions.getShopPosition(state).then(function (snap) {
        const newCoords2 = {lat: snap.latitude, lng: snap.longitude}
        state.markers.forEach(function (marker) {
          marker.setMap(null);
        })
        state.markers = []
        mutations.createMarker(state, newCoords2)
        state.map.setCenter(newCoords2)
        state.showHideMapInput = 'show-map-input'
      })
    }
  },
  //
  goTo_uploadImage_3(state, payload) {
    mutations.getMarkerPosition(state, payload)
  },
  //
  /************************* GOOGLE PLACE API ****************************/
  getSpotTypeSuggestions(state2, payload) { //google place api
    //
    // inti
    let lat = payload.lat
    let lon = payload.lon
    if (state.placeServices) {
      state.placeServices = new google.maps.places.PlacesService(state.map);
      state.placeServices.nearbySearch({
        location: {lat, lng: lon},
        radius: 5000,
        type: [], //types
        rankby: 'distance'
      }, callback)
    }

    //
    function callback(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        //
        let spotTypeArr = []
        for (let i in results) {
          if (i < 5) { //top 3 suggestions
            for (let j in results[i].types) {
              let spotType = results[i].types[j]
              spotTypeArr.push(spotType)
            }
          }
        }
        //
        ls.set('spotTypeSuggestions', JSON.stringify(spotTypeArr))
        //
      }
    }
  }
  /*********************** GOOGLE PLACE API ENDS ************************/
}

const actions = {
  //
  //your current location
  getShopPosition({commit}) {
    return new Promise(function (resolve) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          state.showMap = true //return loc
          resolve(position.coords)
          // pos = position.coords
        }, (err) => {
          let markerLat = ''
          let markerLng = ''
          //
          state.markers.forEach(function (marker) {
            markerLat = marker.getPosition().lat()
            markerLng = marker.getPosition().lng()
          })
          resolve({
            latitude: markerLat,
            longitude: markerLng
          })
          //
          gen.mutations.snackbar_alert(state, {
            msg: err.message
          })
          //
          state.showMap = true //only buttons hide
        })
      }
    })
  },
  arrayOfFormattedAddress(state2, address) {
    return new Promise((resolve) => {
      let a = []
      for (let i in address) {
        a.push(address[i].formatted_address)
      }
      resolve(a)
    })
  },
  //
  //get shop address
  getAddress({commit}, lat, lng) {
    return new Promise(function (resolve) {
      var latlng = {lat, lng}
      axios.post('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latlng.lat + ',' + latlng.lng + '&key=AIzaSyA2kK1nMxVgMkLx3M-hXodPolnlr29_vXs&language=en')
        .then(response => {
          resolve(response.data.results)
        })
        .catch(e => {
          this.errors.push(e)
          resolve('')
        })
      // var geocoder = geocoder = new google.maps.Geocoder()
      /* geocoder.geocode({'location': latlng}, function (results, status) {
         if (status === google.maps.GeocoderStatus.OK) {
           if (results[1]) {
            // results[1].address_components => the address array that you wanted
             resolve(results[1])
           }
           else {
             resolve('')
           }
         }else {
           resolve('')
         }
       }) */
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/uploadImage_3.js